import classNames from 'classnames';
export const getBackgroundColorClassName = (value) => {
    switch (value) {
        case 'cotton':
            return 'sgw-layout--bg__cotton';
        default:
            return '';
    }
};
export const getGridSeperatorSizeClassName = (value) => {
    switch (value) {
        case 'small':
            return 'sgw-layout--grid-seperator-small';
        case 'large':
            return 'sgw-layout-grid-seperator-large';
        default:
            return '';
    }
};
export const getHiddenTypeClassName = (viewTypesToHide) => {
    return classNames({
        'sgw-layout-item__not-mobile': viewTypesToHide === 'mobile',
        'sgw-layout-item__mobile-only': viewTypesToHide === 'desktop',
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0TGF5b3V0Q2xhc3NuYW1lcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL0BlaWthL2VuZ2luZS12aWV3L3NyYy9ncmlkL2dldExheW91dENsYXNzbmFtZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxVQUFVLE1BQU0sWUFBWSxDQUFDO0FBSXBDLE1BQU0sQ0FBQyxNQUFNLDJCQUEyQixHQUFHLENBQUMsS0FBd0IsRUFBRSxFQUFFO0lBQ3BFLFFBQVEsS0FBSyxFQUFFLENBQUM7UUFDWixLQUFLLFFBQVE7WUFDVCxPQUFPLHdCQUF3QixDQUFDO1FBQ3BDO1lBQ0ksT0FBTyxFQUFFLENBQUM7SUFDbEIsQ0FBQztBQUNMLENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLDZCQUE2QixHQUFHLENBQUMsS0FBMEIsRUFBRSxFQUFFO0lBQ3hFLFFBQVEsS0FBSyxFQUFFLENBQUM7UUFDWixLQUFLLE9BQU87WUFDUixPQUFPLGtDQUFrQyxDQUFDO1FBQzlDLEtBQUssT0FBTztZQUNSLE9BQU8saUNBQWlDLENBQUM7UUFDN0M7WUFDSSxPQUFPLEVBQUUsQ0FBQztJQUNsQixDQUFDO0FBQ0wsQ0FBQyxDQUFDO0FBSUYsTUFBTSxDQUFDLE1BQU0sc0JBQXNCLEdBQUcsQ0FBQyxlQUE0QyxFQUFFLEVBQUU7SUFDbkYsT0FBTyxVQUFVLENBQUM7UUFDZCw2QkFBNkIsRUFBRSxlQUFlLEtBQUssUUFBUTtRQUMzRCw4QkFBOEIsRUFBRSxlQUFlLEtBQUssU0FBUztLQUNoRSxDQUFDLENBQUM7QUFDUCxDQUFDLENBQUMifQ==